var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"position-relative d-flex align-items-center justify-content-center",staticStyle:{"min-height":"calc(100vh - 150px)"},attrs:{"fluid":""}},[_c('h2',[_vm._v("Пожалуйста, обратитесь в техническую поддержку!")])])}
var staticRenderFns = []

export { render, staticRenderFns }